import { Helmet } from 'react-helmet-async';
import { Ruler, Wrench, Settings, FileText } from 'lucide-react';
import ContactForm from '../components/forms/ContactForm';

const services = [
  {
    icon: <Ruler className="w-12 h-12 text-primary-600" />,
    title: 'Проектирование и подбор оборудования',
    description: 'Наши специалисты помогут подобрать оптимальное оборудование под ваши задачи, разработают проектную документацию и предоставят техническое обоснование.',
    features: [
      'Расчет и выбор мощности трансформаторов',
      'Проектирование схем подключения',
      'Разработка технической документации',
      'Согласование проектных решений'
    ]
  },
  {
    icon: <Wrench className="w-12 h-12 text-primary-600" />,
    title: 'Монтаж и пусконаладка',
    description: 'Выполняем полный комплекс работ по монтажу и вводу в эксплуатацию трансформаторного оборудования с соблюдением всех технических требований.',
    features: [
      'Монтаж трансформаторов и КТПН',
      'Установка КСО и прокладка кабеля',
      'Пусконаладочные работы',
      'Испытания и измерения'
    ]
  },
  {
    icon: <Settings className="w-12 h-12 text-primary-600" />,
    title: 'Сервисное обслуживание',
    description: 'Обеспечиваем комплексное сервисное обслуживание оборудования в течение всего срока эксплуатации, включая гарантийный и постгарантийный период.',
    features: [
      'Плановое техническое обслуживание',
      'Диагностика и ремонт',
      'Замена комплектующих',
      'Модернизация оборудования'
    ]
  },
  {
    icon: <FileText className="w-12 h-12 text-primary-600" />,
    title: 'Техническая поддержка',
    description: 'Предоставляем полную техническую поддержку и консультации по эксплуатации оборудования, помогаем решать возникающие вопросы.',
    features: [
      'Консультации по эксплуатации',
      'Обучение персонала',
      'Техническая документация',
      'Оперативная поддержка'
    ]
  }
];

export default function ServicesPage() {
  return (
    <>
      <Helmet>
        <title>Услуги - монтаж и обслуживание трансформаторов | Проминнова</title>
        <meta name="description" content="Комплексные услуги по проектированию, монтажу и обслуживанию трансформаторов и электрооборудования. Профессиональный подход, гарантия качества." />
      </Helmet>

      <div className="bg-primary-50 py-12">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Комплексные решения для энергетики
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            От проектирования до сервисного обслуживания – полный спектр услуг для вашего оборудования
          </p>
        </div>
      </div>

      <div className="container-custom py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {services.map((service, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
              <div className="mb-6">{service.icon}</div>
              <h2 className="text-2xl font-bold mb-4">{service.title}</h2>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <ul className="space-y-3">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-600">
                    <div className="w-2 h-2 bg-primary-500 rounded-full mr-3"></div>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold mb-4">Заказать услугу</h2>
              <p className="text-gray-600 mb-6">
                Оставьте заявку, и наш специалист свяжется с вами для обсуждения деталей и составления коммерческого предложения.
              </p>
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-primary-500 rounded-full mr-3"></div>
                  <span>Бесплатная консультация</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-primary-500 rounded-full mr-3"></div>
                  <span>Выезд специалиста на объект</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-primary-500 rounded-full mr-3"></div>
                  <span>Индивидуальный подход</span>
                </div>
              </div>
            </div>
            <div>
              <ContactForm buttonText="Заказать услугу" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}